import Http from "@/commons/Http";
import Utils from "@/utils/Utils";
import PDFBusiness from "@/business/PDFBusiness";

const path = 'api/contract';

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Contract"};
        return Http.post(`${path}/audit?sort=${sort || 'c.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'c.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

    async searchByName(name) {
        if(Utils.isEmptyNullOrUndefined(name)) {
            return this.getAll();
        }
        return Http.get(`${path}/s/${name}/10`);
    },

    async printContract(protocolId){
        const url = `${path}/generate/protocol/${protocolId}`;
        return await PDFBusiness.showPdf(url, null, 'GET');
    },

}
